<ifc-app-scroll-container class="ifp-dashboard-content">
  <ng-container *ngIf="data$ | async as data">
  <div ngClass.gt-xs="layout margin-md" ngClass.xs="layout margin-sm">

    <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="24px">

      <div fxLayout="column" fxLayoutAlign="center center">

        <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill>
          <span class="mat-headline-5">{{data.greeting}}</span>
        </div>

        <div fxLayout="row wrap" fxLayoutAlign="start start" *ngIf="data.hasAvailableOffers" fxFlexFill>
          <span class="mat-headline-6">Check out your offers below.</span>
        </div>

        <div fxLayout="row wrap" fxLayoutAlign="start start" *ngIf="data.allActiveLoans?.length > 1" fxFlexFill>
          <ifp-dashboard-account-action-buttons [caseFinancingLoans]="data.activeCFLoans" [otherLoans]="data.activeLoans" [applications]="data.applications"
            [currentSsoAccount]="data.currentSsoAccount" [checkoutState]="data.checkoutState" [isBankVerified]="data.entity?.isVerified" [needsAttentionModel]="data.needsAttentionModel">
          </ifp-dashboard-account-action-buttons>
        </div>

        <div fxLayout="row wrap" fxLayoutAlign="center start" fxLayout.lt-md="column" fxLayoutAlign.lt-md="center start"
          fxLayoutGap.gt-sm="24px">

          <div fxLayout="column" fxLayoutGap="8px" ngClass.xs="full-width">

            <div fxLayout="column" fxLayoutAlign="center start" *ngIf="data.nonCfApplications?.length">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" fxFlex="50"
                class="layout padding-vertical-md">
                <div><span class="mat-headline-6">Applications</span></div>
                <div fxLayoutAlign="center">
                  <mat-icon class="mat-orange" matTooltip="Action required" *ngIf="data.nonCfApplicationsActionRequired">error
                  </mat-icon>
                </div>
              </div>
              <mat-card appearance="raised" *ngFor="let application of data.nonCfApplications; let currentIndex = index;"
                class="mat-elevation-z2 account-widget" [ngClass]="{
                'top-card': data.nonCfApplications.length > 1 && currentIndex === 0,
                'middle-card': data.nonCfApplications.length > 1 && currentIndex > 0,
                'bottom-card': data.nonCfApplications.length > 1 && currentIndex === data.nonCfApplications.length - 1}">
                <mat-card-content fxLayout="column" fxLayoutAlign="center start">
                  <ifp-dashboard-application-widget [application]="application" [entity]="data.entity" [isBankLinked]="!data.noLinkedBanks">
                  </ifp-dashboard-application-widget>
                </mat-card-content>
              </mat-card>
            </div>

            <div fxLayout="column" fxLayoutAlign="center start" *ngIf="data.cfApplications?.length">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" fxFlex="50"
                class="layout padding-vertical-md">
                <div><span class="mat-headline-6">Case Submission</span></div>
                <div fxLayoutAlign="center">
                  <mat-icon class="mat-orange" matTooltip="Action required" *ngIf="data.cfApplicationsActionRequired">error
                  </mat-icon>
                </div>
              </div>
              <mat-card appearance="raised" *ngFor="let application of data.cfApplications; let currentIndex = index;"
                class="mat-elevation-z2 account-widget" [ngClass]="{
                'top-card': data.cfApplications.length > 1 && currentIndex === 0,
                'middle-card': data.cfApplications.length > 1 && currentIndex > 0,
                'bottom-card': data.cfApplications.length > 1 && currentIndex === data.cfApplications.length - 1}">
                <mat-card-content fxLayout="column" fxLayoutAlign="center start">
                  <ifp-dashboard-application-widget [application]="application" [entity]="data.entity" [isBankLinked]="!data.noLinkedBanks">
                  </ifp-dashboard-application-widget>
                </mat-card-content>
              </mat-card>
            </div>

            <div fxLayout="column" fxLayoutAlign="center start" *ngIf="data.loans?.length || data.accountsFiltered">
              <div fxLayout="row" fxLayoutAlign="space-between center"  fxFlex="50" class="layout padding-vertical-md account-widget">
                <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
                  <div>
                    <span class="mat-headline-6">Financing</span>
                  </div>
                  <div fxLayoutAlign="center">
                    <mat-icon class="mat-orange" matTooltip="Action required" *ngIf="data.financingActionRequired">error
                    </mat-icon>
                  </div>

                </div>

              </div>

              <div class="layout padding-vertical-md account-widget" fxLayout="row">
                <ifp-loyalty-reward-widget
                  [interestRateReduction]="data.loyaltyRewardEligibleLoan?.loyaltyReward?.interestRateReduction"
                  *ngIf="!!data.loyaltyRewardEligibleLoan"
                  (viewDetails)="openLoyaltyRewardDialog()"></ifp-loyalty-reward-widget>
              </div>

              <mat-card appearance="raised" class="mat-elevation-z2 account-widget"
                *ngFor="let loan of data.activeLoans | slice:0:3; let currentIndex = index;"
                [ngClass]="{
                'loc-card': loan?.productCode === data.productCodes.LOC && data.activeLoans.length === 1,
                'tl-card': loan?.productCode === data.productCodes.Term && data.activeLoans.length === 1,
                'top-card': data.activeLoans.length > 1 && currentIndex === 0,
                'top-loc-card': loan?.productCode === data.productCodes.LOC && data.activeLoans.length > 1 && currentIndex === 0,
                'top-tl-card': loan?.productCode === data.productCodes.Term && data.activeLoans.length > 1 && currentIndex === 0,
                'middle-card': data.activeLoans.length > 1 && currentIndex > 0,
                'middle-loc-card': loan?.productCode === data.productCodes.LOC && data.activeLoans.length > 1 && currentIndex > 0,
                'middle-tl-card': loan?.productCode === data.productCodes.Term && data.activeLoans.length > 1 && currentIndex > 0,
                'bottom-card': data.activeLoans.length > 1 && (currentIndex === 2 || currentIndex === data.activeLoans.length - 1),
                'bottom-loc-card': loan?.productCode === data.productCodes.LOC && data.activeLoans.length > 1 && (currentIndex === 2 || currentIndex === data.activeLoans.length - 1),
                'bottom-tl-card': loan?.productCode === data.productCodes.Term && data.activeLoans.length > 1 && (currentIndex === 2 || currentIndex === data.activeLoans.length - 1)}">
                <mat-card-content fxLayout="column" fxLayoutAlign="center start">
                  <form [formGroup]="data.form" *ngIf="data.loans?.length > 3 && currentIndex === 0" class="search" [ngClass]="{
                    'search-collapsed': data.showAccountsFilter === false,
                    'search-expanded': data.showAccountsFilter === true}">
                    <ifp-account-search-input [fc]="data.form.get('search')" (enter)="setShowAccountsFilter(data, $event)" [excludedProductCode]="data.productCodes.Law" [entityId]="data.entity?.id" fxFlexFill (backAction)="closeFilterLoans(data)" (clearInput)="filterLoans(data, undefined)" (autocompleteOptionSelected)="filterLoans(data, $event)">
                    </ifp-account-search-input>
                  </form>
                  <ifp-dashboard-account-widget [currentLoan]="loan" [currentSsoAccount]="data.currentSsoAccount" [checkoutState]="data.checkoutState" [needsAttentionModel]="data.needsAttentionModel">
                  </ifp-dashboard-account-widget>
                </mat-card-content>
              </mat-card>
              <div class="message-box info" *ngIf="!data.activeLoans.length" fxLayout="row" fxLayoutGap="12px"
              fxLayoutAlign="start center">
                <mat-icon class="icon">info</mat-icon>
                <span>No open loans available.</span>
              </div>
              <div class="layout padding-top-sm" fxLayout="row" fxLayoutAlign="end start" fxFlexFill>
                <button mat-button *ngIf="data.loans?.length > 3 || data.activeLoans?.length < data.loans?.length" routerLink="/accounts">
                  SEE ALL LOANS
                </button>
              </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="center start" *ngIf="data.cfLoans?.length || data.caseFinancingFiltered">
              <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="50" class="layout case-financing-title account-widget">
                <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
                  <div>
                    <span class="mat-headline-6">Case Financing</span>
                  </div>
                  <div fxLayoutAlign="center">
                    <mat-icon class="mat-orange" matTooltip="Action required" *ngIf="data.caseFinancingActionRequired">error</mat-icon>
                  </div>
                </div>
              </div>
              <div *ngIf="data.firstActiveCFLoan" fxLayout="row" fxLayoutAlign="start center" class="layout available-funds">
                <span class="subtitle-number">{{data.firstActiveCFLoan?.loanInfo?.availableFunds | shortNumber:'0'}}</span>
                <span class="subtitle secondary-text">available of</span>
                <span class="subtitle-number">{{data.firstActiveCFLoan?.loanInfo?.msaCreditLimit | shortNumber:'0'}}</span>
                <span class="subtitle secondary-text">line limit</span>
                <mat-icon (click)="showAvailableFundsDialog(data)">info</mat-icon>
              </div>
              <mat-card appearance="raised" class="mat-elevation-z2 account-widget"
                *ngFor="let loan of data.activeCFLoans | slice:0:3; let currentIndex = index;" [ngClass]="{
                'law-card': data.activeCFLoans.length === 1,
                'top-card': data.activeCFLoans.length > 1 && currentIndex === 0,
                'top-law-card': data.activeCFLoans.length > 1 && currentIndex === 0,
                'middle-card': data.activeCFLoans.length > 1 && currentIndex > 0,
                'middle-law-card': data.activeCFLoans.length > 1 && currentIndex > 0,
                'bottom-card': data.activeCFLoans.length > 1 && (currentIndex === 2 || currentIndex === data.activeCFLoans.length - 1),
                'bottom-law-card': data.activeCFLoans.length > 1 && (currentIndex === 2 || currentIndex === data.activeCFLoans.length - 1)}">
                <mat-card-content fxLayout="column" fxLayoutAlign="center start">
                  <form [formGroup]="data.form"  class="search" *ngIf="data.cfLoans?.length > 3 && currentIndex === 0" [ngClass]="{
                    'search-collapsed': data.showCaseFinanceFilter === false,
                    'search-expanded': data.showCaseFinanceFilter === true}">
                    <ifp-account-search-input (enter)="setShowCaseFinanceFilter(data, $event)" [productCode]="data.productCodes.Law" [entityId]="data.entity?.id" [fc]="data.form.get('search')" fxFlexFill (backAction)="closeFilterCFLoans(data)" (clearInput)="filterCFLoans(data, undefined)" (autocompleteOptionSelected)="filterCFLoans(data, $event)">
                    </ifp-account-search-input>
                  </form>
                  <ifp-dashboard-account-widget [currentLoan]="loan" [loansTemplates]="data.cfLoanTemplates" [currentSsoAccount]="data.currentSsoAccount" [checkoutState]="data.checkoutState" [needsAttentionModel]="data.needsAttentionModel">
                  </ifp-dashboard-account-widget>
                </mat-card-content>
              </mat-card>
              <div class="message-box info" *ngIf="!data.activeCFLoans.length" fxLayout="row" fxLayoutGap="12px"
              fxLayoutAlign="start center">
                <mat-icon class="icon">info</mat-icon>
                <span>No open cases available.</span>
              </div>
              <div class="layout padding-top-sm" fxLayout="row" fxLayoutAlign="end start" fxFlexFill fxLayoutGap="8px">
                <button mat-button *ngIf="(data.cfLoans?.length > 3 || data.activeCFLoans?.length < data.cfLoans?.Length)" routerLink="/case-financing">SEE ALL CASES</button>
                <button mat-button color="primary" (click)="fundAnotherCase()">FUND ANOTHER CASE</button>
              </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="center stretch">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" fxFlex="50"
                class="layout padding-vertical-md">
                <div><span class="mat-headline-6">Banks</span></div>
                <div fxLayoutAlign="center">
                  <mat-icon class="mat-orange" matTooltip="Action required" *ngIf="data.noLinkedBanks">error</mat-icon>
                </div>
                <div fxLayout="row" fxLayoutAlign="end start" fxFlex>
                  <button mat-button color="primary" (click)="link()">
                    <span class="btn-label" *ngIf="!data.noLinkedBanks">LINK ANOTHER BANK</span>
                    <span class="btn-label" *ngIf="data.noLinkedBanks">LINK BANK</span>
                  </button>
                </div>
              </div>
              <mat-card appearance="raised" *ngFor="let bank of data.banks; let currentIndex = index;" class="mat-elevation-z2 account-widget"
                [ngClass]="{
                'bank-card': data.banks.length === 1,
                'top-card': data.banks.length > 1 && currentIndex === 0,
                'top-bank-card': data.banks.length > 1 && currentIndex === 0,
                'middle-card': data.banks.length > 1 && currentIndex > 0,
                'middle-bank-card': data.banks.length > 1 && currentIndex > 0,
                'bottom-card': data.banks.length > 1 && currentIndex === data.banks.length - 1,
                'bottom-bank-card': data.banks.length > 1 && currentIndex === data.banks.length - 1}">
                <mat-card-content fxLayout="column" fxLayoutAlign="center start">
                  <ifp-dashboard-bank-widget [bank]="bank" [entity]="data.entity"></ifp-dashboard-bank-widget>
                </mat-card-content>
              </mat-card>
              <mat-card class="mat-elevation-z1 layout-padding-top-sm account-widget" *ngIf="!data.banks?.length">
                <mat-card-content fxLayout="column" fxLayoutAlign="center stretch">
                  <div fxLayout="row" fxLayoutAlign="start center" class="layout padding-top-sm">
                    <span class="mat-body-1"> Link your financial institution to speed up the funding process </span>
                  </div>
                </mat-card-content>
              </mat-card>
              <div class="layout-padding-top-sm"> &nbsp; </div>
              <mat-card class="mat-elevation-z1 layout-padding-top-sm account-widget mat-lighter-grey-bg" *ngIf="data.banks?.length">
                <mat-card-content fxLayout="column" fxLayoutAlign="center stretch">
                  <div fxLayout="row" fxLayoutAlign="start center" class="layout">
                    <span class="mat-body-2"> To update your Disbursement and Payment Accounts, contact your business advisor.
                    </span>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center" class="layout padding-top-sm">
                    <div class="avatar medium mat-light-grey-bg icon"> D </div>
                    <div>
                      <span class="mat-body-1"> Disbursement - Institution where we will deposit your draws</span>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center" class="layout padding-top-sm">
                    <div class="avatar medium mat-light-grey-bg icon"> P </div>
                    <div>
                      <span class="body-1"> Payment - Institution where we collect payments from </span>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <div fxLayout="column" fxLayoutAlign="center start" *ngIf="data.recentDocuments?.length">
              <div fxLayout="row" fxLayoutAlign="start center" class="layout padding-top-md">
                <div class="mat-headline-6">Recent documents</div>
              </div>
              <mat-card appearance="raised" class="mat-elevation-z2 account-widget">
                <mat-card-content fxLayout="column" fxLayoutAlign="center start" class="table-card-content">
                  <ifp-recent-documents-widget [recentDocuments]="data.recentDocuments"></ifp-recent-documents-widget>
                </mat-card-content>
              </mat-card>
              <div fxLayout="row" fxLayoutAlign="end start" class="layout padding-top-sm" fxFlexFill>
                <button mat-button color="primary" routerLink="/documents">
                  <span class="btn-label">SEE ALL DOCUMENTS</span>
                </button>
              </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="center start" *ngIf="data.recentActivity?.length">
              <div fxLayout="row" fxLayoutAlign="start center" class="layout padding-top-md">
                <div class="mat-headline-6">Recent activity</div>
              </div>
              <mat-card appearance="raised" class="mat-elevation-z2 account-widget recent-activity-card">
                <mat-card-content fxLayout="column" fxLayoutAlign="center start" class="table-card-content">
                  <ifp-recent-activity-widget [recentActivity]="data.recentActivity"></ifp-recent-activity-widget>
                </mat-card-content>
              </mat-card>
            </div>
          </div>

          <div fxLayout="column" fxLayoutAlign="center center" ngClass.lt-md="layout padding-top-sm" fxLayoutGap="24px">
            <div class="header-space" fxHide.lt-md></div>
            <ifp-dashboard-offer-widget *ngIf="data.renewalEligibilityMessage" [message]="data.renewalEligibilityMessage" [entity]="data.entity">
            </ifp-dashboard-offer-widget>
             <ifp-announcement-widget *ngFor="let announcement of data.announcements" [announcement]="announcement">
            </ifp-announcement-widget>
            <ifp-dashboard-offer-widget *ngFor="let message of data.messages" [message]="message" [entity]="data.entity"
              (dismiss)="dismissMessage(data, message)">
            </ifp-dashboard-offer-widget>
            <ifp-advisor-widget></ifp-advisor-widget>
            <ifc-finance-contact-widget class="finance-contact"></ifc-finance-contact-widget>
          </div>
        </div>

      </div>

    </div>

  </div>
  </ng-container>
</ifc-app-scroll-container>

